import { render, staticRenderFns } from "./task-console.vue?vue&type=template&id=38abf7f2"
import script from "./task-console.vue?vue&type=script&lang=js"
export * from "./task-console.vue?vue&type=script&lang=js"
import style0 from "./task-console.vue?vue&type=style&index=0&id=38abf7f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports